// apiConfig.js
export const API_BASE_URL =
  process.env.NEXT_PUBLIC_API_BASE_URL || "https://api.aztender.az/api";

// You can add more reusable configurations like headers, timeout, etc.
export const API_TIMEOUT = 15000; // Example: 5 seconds timeout